export default __webpack_public_path__ + "static/media/plus-icon.eaa975a9.svg";